
<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Liste des groupes SIREN</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="data" :options="options">
          <div slot="createur" slot-scope="props">
              {{ props.row.createur.prenom }} {{ props.row.createur.nom }}
          </div>
          <div slot="action" slot-scope="props">
            <b-button type="button" @click.prevent="destroy(props.row.id)" class="badge badge-danger mr-3 p-2"><i
              class="fa fa-remove"></i> Supprimer
            </b-button>
            <b-button type="button" @click="editGroupSiren(props.row.id)" class="badge badge-primary p-2">
              <i class="fa fa-eye"></i> Voir
            </b-button>
          </div>
        </v-client-table>
      </b-card-body>
      <div slot="footer" class="btn-footer">
        <b-button type="button" @click="addGroupSiren" class="pull-right" size="md" variant="primary">
          <i class="fa fa-plus"></i> Ajouter un groupe
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";

  export default {
    name: "GestionGroupesSiren",
    data() {
      return {
        columns: ['libelle', 'type', 'createur','action'],
        data: [],
        options: {
          headings: {
            libelle: 'Libellé',
            type: 'Type',
            createur: 'Créé par',
            action: 'Action'
          },
          columnsClasses: {
            action: "action-md"
          },
          sortable: ['libelle', 'type'],
          filterable: ['libelle', 'type', 'createur'],
          perPage: 10,
          perPageValues: [10, 25, 50],
          texts: {
            filterPlaceholder: "Libellé, Type, Créé par"
          },
          orderBy: {column: 'libelle', ascending: false}
        }
      }
    },
    mounted() {
      this.all()
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      all() {
        this.$axios
          .get("/espaceQualite/groupes-siren")
          .then(response => {
            this.data = response.data.data;
          })
          .catch(() => {
            this.handleErrors();
          });
      },
      destroy(id) {
        this.$swal
          .fire({
            title: 'Êtes-vous sûr?',
            text: "Voulez-vous vraiment supprimer ce groupe ?",
            type: 'warning',
            reverseButtons: true,
            showCancelButton: true,
            cancelButtonColor: "#ff1744",
            confirmButtonText: 'Annuler',
            cancelButtonText: 'Supprimer',
          })
          .then((result) => {
            if (!result.value) {
              this.$store.commit('IS_LOADING', true)
              this.$axios
                .post("/espaceQualite/groupes-siren/delete/" + id)
                .then(() => {
                  this.$store.commit('IS_LOADING', false)
                  this.$swal({
                    position: 'top',
                    type: 'success',
                    title: 'Suppression avec succès',
                    text: "Le groupe a bien été supprimé",
                    showConfirmButton: false,
                    timer: 5000
                  });
                  this.all();
                })
                .catch(() => {
                  this.handleErrors();
                });
            }
          })
      },
      addGroupSiren() {
        this.$router.push({path: '/espace-gestion/groupes-siren/add'})
      },
      editGroupSiren(id) {
        this.$router.push({path: '/espace-gestion/groupes-siren/edit/' + id})
      },
      attachSirens() {
        this.$router.push({path: "/espace-gestion/groupes-siren/attacher-sirens"});
      },
      handleErrors() {
        this.$store.commit('IS_LOADING', false);
        this.$swal({
          position: 'top',
          type: 'warning',
          title: 'Attention !!',
          text: 'Un problème est survenu, merci de contacter un administrateur',
          showConfirmButton: false,
          timer: 4000,
        });
      }
    }
  }
</script>

<style scoped>
  .btn-footer {
    display: flex;
    justify-content: space-between;
  }
</style>

